import { Route, Router, Routes, BrowserRouter } from "react-router-dom";
import Layout from "./layout/Layout";
import Home from "./screens/Home";
import PhosphorIconInit from "./PhosphorColorInt";
import LogIn from "./screens/LogIn";
import Register from "./screens/Register";
import Shop from "./screens/Shop";
import Cart from "./screens/Cart";
import ContactUs from "./screens/ContactUs";
import SingleProduct from "./screens/SingleProduct";
import AboutUs from "./screens/AboutUs";
import DashBoard from "./screens/DashBoard";
import { ToastContainer } from "react-toastify";
import MyOrder from "./screens/MyOrder";
import Address from "./screens/Address";
import OrderDetails from "./screens/OrderDetails";
import Loader from "./component/Loader";
import { useContext } from "react";
import { userContext } from "./context/UserContext";
import Checkout from "./screens/Checkout";
import OrderSuccess from "./screens/ProductSucces";

function App() {
  const {load} = useContext(userContext)
  return (
    <>
      {load && <Loader />}
      <ToastContainer />
      <BrowserRouter>
        <PhosphorIconInit />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/login"
            element={
              <Layout>
                <LogIn />
              </Layout>
            }
          />
          <Route
            path="/register"
            element={
              <Layout>
                <Register />
              </Layout>
            }
          />
          <Route
            path="/shop"
            element={
              <Layout>
                <Shop />
              </Layout>
            }
          />
          <Route
            path="/cart"
            element={
              <Layout>
                <Cart />
              </Layout>
            }
          />
          <Route
            path="/checkout"
            element={
              <Layout>
                <Checkout />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout>
                <ContactUs />
              </Layout>
            }
          />
          <Route
            path="/singleProduct"
            element={
              <Layout>
                <SingleProduct />
              </Layout>
            }
          />
          <Route
            path="/about"
            element={
              <Layout>
                <AboutUs />
              </Layout>
            }
          />
          <Route
            path="/ordersuccess"
            element={
              <Layout>
                <OrderSuccess />
              </Layout>
            }
          />
          <Route
            path="/dashboard"
            element={
              <Layout>
                <DashBoard />
              </Layout>
            }
          />
          <Route
            path="/my-order"
            element={
              <Layout>
                <MyOrder />
              </Layout>
            }
          />
          <Route
            path="/address"
            element={
              <Layout>
                <Address />
              </Layout>
            }
          />
          <Route
            path="/order-detail"
            element={
              <Layout>
                <OrderDetails />
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
